import dayjs from "@/plugins/vue-dayjs";

export const initExpoProgram = (form = {}) => ({
    ...(form || {}),

    _thumb: form?._thumb || null,
    thumb: form?.thumb || null,

    _image: form?._image || null,
    image: form?.image || null,

    _employees: [...(form?._employees || [])],
    _employeeUsers: [...(form?._employeeUsers || [])],

    _employers: [...(form?._employers || [])],
    _employerUsers: [...(form?._employerUsers || [])],

    subject: form?.subject || null,
    summary: form?.summary || null,
    content: form?.content || null,

    tags: [...(form?.tags || [])],

    host: {
        ...(form?.host || {}),

        _user: form?.host?._user || null,

        name: form?.host?.name || null,
        email: form?.host?.email || null,
        phone: form?.host?.phone || null,

        workerName: form?.host?.workerName || null,
    },

    date: {
        ...(form?.date || {}),

        programDisplay: initDate(form?.date?.programDisplay),
        employerSubmit: initDate(form?.date?.employerSubmit),
        employeeSubmit: initDate(form?.date?.employeeSubmit),
        matchingSubmit: initDate(form?.date?.matchingSubmit),
        interviewSpans: initDate(form?.date?.interviewSpans),
    },
});

const initDate = (form = {}) => ({
    ...(form || {}),

    startsAt: form?.startsAt ?? null,
    endsAt: form?.endsAt ?? null,

    text: initDateText(form),
});

const initDateText = ({ startsAt, endsAt }) => {
    let prev = dayjs(startsAt).format("YY.MM.DD");
    let next = dayjs(endsAt).format("YY.MM.DD");

    return `${prev} ~ ${next}`;
};
